import(/* webpackMode: "eager" */ "/vercel/path0/src/app/payment/page.tsx");
